module.exports = __webpack_public_path__ + "img/Bliks_colorido.d352f8f1.png";